<li class="m-radio"
    :class="{ 'm--is-disabled': propDisabled,
              'm--is-readonly': propReadonly,
              'm--is-error': propError,
              'm--is-valid': propValid,
              'm--is-checked': isChecked,
              'm--is-focus': hasFocus && !propDisabled,
              'm--is-input-right': propPosition === 'right',
              'm--is-inline': propInline,
              'm--is-align-center': propVerticalAlign === 'center' }">
    <input class="m-radio__hidden"
           @focus="onFocus"
           @blur="onBlur"
           :aria-hidden="propDisabled"
           :disabled="propDisabled || isReadonlyUnchecked"
           :id="radioID"
           :name="propName"
           :value="value"
           v-model="model"
           type="radio"
           ref="radioInput" />
    <label class="m-radio__wrap"
           ref="label"
           :for="radioID">
        <span class="m-radio__input"
              :style="{ 'margin-top': propRadioMarginTop }"
              aria-hidden="true"></span>
        <span class="m-radio__label">
            <slot></slot>
        </span>
    </label>
</li>
